interface DemoUser {
  name: string;
  avatar: string;
  gender: string;
}

class RandomUserService {
  // Static predefined users for each role - no API calls needed
  private staticUsers = {
    customer: [
      { name: 'Sarah Johnson', avatar: 'https://ui-avatars.com/api/?name=Sarah+Johnson&background=4f46e5&color=fff&size=48', gender: 'female' },
      { name: 'Michael Chen', avatar: 'https://ui-avatars.com/api/?name=Michael+Chen&background=059669&color=fff&size=48', gender: 'male' },
      { name: 'Emily Rodriguez', avatar: 'https://ui-avatars.com/api/?name=Emily+Rodriguez&background=dc2626&color=fff&size=48', gender: 'female' },
      { name: 'David Wilson', avatar: 'https://ui-avatars.com/api/?name=David+Wilson&background=7c3aed&color=fff&size=48', gender: 'male' },
      { name: 'Jessica Martinez', avatar: 'https://ui-avatars.com/api/?name=Jessica+Martinez&background=ea580c&color=fff&size=48', gender: 'female' }
    ],
    agent: [
      { name: 'Alex Thompson', avatar: 'https://ui-avatars.com/api/?name=Alex+Thompson&background=0891b2&color=fff&size=48', gender: 'male' },
      { name: 'Maria Garcia', avatar: 'https://ui-avatars.com/api/?name=Maria+Garcia&background=be185d&color=fff&size=48', gender: 'female' },
      { name: 'Kevin Rodriguez', avatar: 'https://ui-avatars.com/api/?name=Kevin+Rodriguez&background=16a34a&color=fff&size=48', gender: 'male' },
      { name: 'Lisa Anderson', avatar: 'https://ui-avatars.com/api/?name=Lisa+Anderson&background=9333ea&color=fff&size=48', gender: 'female' },
      { name: 'Ryan Martinez', avatar: 'https://ui-avatars.com/api/?name=Ryan+Martinez&background=c2410c&color=fff&size=48', gender: 'male' }
    ],
    admin: [
      { name: 'Admin Smith', avatar: 'https://ui-avatars.com/api/?name=Admin+Smith&background=1f2937&color=fff&size=48', gender: 'male' },
      { name: 'System Manager', avatar: 'https://ui-avatars.com/api/?name=System+Manager&background=374151&color=fff&size=48', gender: 'female' },
      { name: 'IT Director', avatar: 'https://ui-avatars.com/api/?name=IT+Director&background=4b5563&color=fff&size=48', gender: 'male' },
      { name: 'Platform Admin', avatar: 'https://ui-avatars.com/api/?name=Platform+Admin&background=6b7280&color=fff&size=48', gender: 'female' },
      { name: 'Tech Support', avatar: 'https://ui-avatars.com/api/?name=Tech+Support&background=9ca3af&color=fff&size=48', gender: 'male' }
    ]
  };

  private selectedUsers: { [key: string]: DemoUser } = {};

  /**
   * Get a consistent demo user for the role - no API calls, just static data
   */
  async generateDemoUser(role: string, gender?: 'male' | 'female'): Promise<DemoUser> {
    // Return cached user for consistency
    if (this.selectedUsers[role]) {
      return this.selectedUsers[role];
    }

    const users = this.staticUsers[role as keyof typeof this.staticUsers] || this.staticUsers.customer;
    
    // Filter by gender if specified
    const filteredUsers = gender ? users.filter(user => user.gender === gender) : users;
    const availableUsers = filteredUsers.length > 0 ? filteredUsers : users;
    
    // Select a random user from available options
    const selectedUser = availableUsers[Math.floor(Math.random() * availableUsers.length)];
    
    // Cache for consistency
    this.selectedUsers[role] = selectedUser;
    
    return selectedUser;
  }

  /**
   * Clear the cache to generate new random users
   */
  clearCache(): void {
    this.selectedUsers = {};
  }

  /**
   * Get a cached user or generate a new one
   */
  async getDemoUser(role: string, gender?: 'male' | 'female'): Promise<DemoUser> {
    return this.generateDemoUser(role, gender);
  }
}

export const randomUserService = new RandomUserService();
export type { DemoUser }; 